import { gql, TypedDocumentNode } from '@apollo/client';

export const GUEST_LOGIN = gql`
  mutation GuestLogin($isExternalCheck: Boolean) {
    guestLogin(isExternalCheck: $isExternalCheck) {
      subject
      actions
    }
  }
`;

export const EMAIL_LOGIN = gql`
  mutation EmailLogin($emailLoginInput: EmailLoginInput!) {
    emailLogin(emailLoginInput: $emailLoginInput) {
      subject
      actions
    }
  }
`;

export const PIN_LOGIN = gql`
  mutation PinLogin($pinLoginInput: PinLoginInput!) {
    pinLogin(pinLoginInput: $pinLoginInput) {
      subject
      actions
    }
  }
`;

export const CHANGE_EMAIL_PASSWORD = gql`
  mutation ChangeEmailPassword($email: String!, $newPassword: String!, $userId: Int!) {
    changeEmailPassword(email: $email, newPassword: $newPassword, userId: $userId)
  }
`;

export const CHANGE_PIN = gql`
  mutation ChangePin($newPin: String!, $userId: Int!) {
    changePin(newPin: $newPin, userId: $userId)
  }
`;

export const UPDATE_USER: TypedDocumentNode<
  { updateUser: { id: number } },
  { updateUserInput: { id: number; preferedLanguage: string } }
> = gql`
  mutation updateUser($updateUserInput: UpdateUser) {
    updateUser(updateUserInput: $updateUserInput) {
      id
    }
  }
`;
